import { Directive, HostListener } from '@angular/core';
// Added 'blockDateTyping' directive to block typing  in dx-datepicker
@Directive({
    selector: '[blockDateTyping]',
    standalone: false
})
export class BlockDateTypingDirective {
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        const allowedKeys = ['Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

        if (!allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
    }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        event.preventDefault();
    }
}
